"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CancellationReasons {
}
exports.default = CancellationReasons;
//# sourceMappingURL=CancellationReasons.js.map